import { Outlet } from "react-router-dom";
import logo from "../../../assets/img/logo/transparent_logo.png";

export const ExternalProviderOutlet = () => {
  return (
    <div className="flex min-h-screen flex-col items-center bg-slate-900 px-4 sm:px-6">
      <div className="w-[200px] pt-6 sm:w-[250px] sm:pt-8">
        <img src={logo} alt="logo" className="w-full" />
      </div>
      <div className="w-full max-w-[700px] pb-8">
        <Outlet />
      </div>
    </div>
  );
};
